<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { MEMBERS } from '@/store/types';
import membersApi from '../../apis/members.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
    commute_recommendation: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = membersApi.useCustomSentEmailsQuery({
      page: props.page,
      per_page: props.per_page,
      commute_recommendation: props.commute_recommendation,
    });
    if (query.value) {
      store.commit(MEMBERS.SET_CUSTOMEMAILS_SENT_QUERY, query);
    }
    return { query };
  },
};
</script>
